var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2679 7.28155C16.2679 3.26006 13.0547 0 9.09091 0C5.12714 0 1.91388 3.26006 1.91388 7.28155V11.699C0.821895 11.9239 0 12.9034 0 14.0777C0 15.4182 1.07109 16.5049 2.39234 16.5049H6.2201V17.0874C6.2201 18.696 7.5054 20 9.09091 20C10.6764 20 11.9617 18.696 11.9617 17.0874V16.5049H15.7895C17.1107 16.5049 18.1818 15.4182 18.1818 14.0777C18.1818 12.9034 17.3599 11.9239 16.2679 11.699V7.28155ZM15.7895 13.0097H2.39234C1.81099 13.0097 1.33971 13.4879 1.33971 14.0777C1.33971 14.6675 1.81099 15.1456 2.39234 15.1456H6.2201H11.9617H15.7895C16.3708 15.1456 16.8421 14.6675 16.8421 14.0777C16.8421 13.4879 16.3708 13.0097 15.7895 13.0097ZM14.9282 11.6505V7.28155C14.9282 4.01074 12.3148 1.35922 9.09091 1.35922C5.86705 1.35922 3.25359 4.01074 3.25359 7.28155V11.6505H14.9282ZM10.622 16.5049H7.55981V17.0874C7.55981 17.9453 8.24531 18.6408 9.09091 18.6408C9.93651 18.6408 10.622 17.9453 10.622 17.0874V16.5049Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.b8628d68504512cfb571e6e8eb997445.svg";
export { ForwardRef as ReactComponent };